'use client'

import {
  Col,
  LoadMoreSection,
  Skeleton,
  Typography,
  Row,
  Badge,
} from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import {
  useAgentListAvailableProjects,
  useAgentListMyProjects,
} from '@repo/services'
import { AddProjectsPropertiesEmptyState } from './add-projects.available-properties.empty-state'
import { PropertyCard } from '@/containers/dashboard'

export const ProjectsAvailableProperties = () => {
  const { t } = useTranslate()

  const { data, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useAgentListAvailableProjects({
      skip: 0,
      limit: 2,
    })

  const projects = (
    data?.pages.flatMap((page) => page.data?.projects || []) || []
  ).filter((project) => project.kind === 'property')

  const { data: dataAgentProjects } = useAgentListMyProjects({
    skip: 0,
    limit: 5,
  })
  const agentProjectsTotal = (
    dataAgentProjects?.pages.flatMap((page) => page.data?.projects || []) || []
  ).length

  const availableCapacity = 5 - (+agentProjectsTotal || 0)
  return (
    <Col className='gap-md w-full rounded-sm md:p-md'>
      <Row className='gap-2xs px-md md:px-0 '>
        <Typography variant='p' size='md' color='text-neutral-surface-100'>
          {t('dashboardAgent_addProjectPage_rules_section_first')}
        </Typography>
        <Badge size='lg' color='base' variant='liquid'>
          {availableCapacity}{' '}
          {t('dashboardAgent_addProjectPage_rules_section_second')}
        </Badge>
        <Typography variant='p' size='md' color='text-neutral-surface-100'>
          {t('dashboardAgent_addProjectPage_rules_section_third')}
        </Typography>
      </Row>
      <Row className='gap-md px-md md:px-0 '>
        <Typography variant='p' size='sm' color='text-neutral-surface-100'>
          {t('dashboardAgent_addProjectPage_description')}
        </Typography>
      </Row>

      <Col className='flex-1 gap-md'>
        {projects.map((property, index) => (
          <PropertyCard
            key={index}
            property={property}
            className='md:border  md:border-neutral-surface-dark rounded-sm'
            layout='add-project'
          />
        ))}

        {isLoading && (
          <Col className='gap-md px-md'>
            {Array.from({ length: 10 }).map((_, index) => (
              <Skeleton
                key={index}
                className='w-full h-20  bg-neutral-surface-light rounded-md '
              />
            ))}
          </Col>
        )}

        {projects.length === 0 && <AddProjectsPropertiesEmptyState />}
      </Col>

      <LoadMoreSection
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
      />
    </Col>
  )
}
